export function getRandomIntBetween(min: number, max: number) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function isNumeric(value: any) {
  if (typeof value === 'number') {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  let coercedValue = parseFloat(value);
  return Number.isFinite(coercedValue);
}
